import React from 'react';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import SearchResult from "./SearchResult";
import axios from "axios";
import {ST} from "../global/SystemText";
import {canScan, scanCode} from "../global/Scanner";
import * as PT from "../global/PortalTools";
import {Session} from "../global/PortalTools";
import {Link} from "react-router-dom";
import WarningDialog from "../components/WarningDialog";

export default  class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            options: [],
            showSearch: false,
            showProductEanWarning: false,
            number:0,
            selected:[]
        };

    }

    componentDidMount() {
        window.addEventListener('showSearch', function (e) {
            this.setState({
                showSearch: !this.state.showSearch
            });
        }.bind(this));


    }

    componentWillUnmount() {
        window.removeEventListener('showSearch', function () {
        });
    }



    _scanBarCode = () => {
        scanCode().then((text) => {
            if (text) {
                this._getProductIdByEan(text);
            }
        });
    };


    _getProductIdByEan = (ean) => {
        axios.get(Session.getItem("endpoint") + 'PortalServlet',
            {
                params: {
                    idMandant: Session.idMandant,
                    idContact: Session.getItem("idContact"),
                    idCompany: Session.getItem("idCompany"),
                    ean: ean,
                    action: "GET_PRODUCT_ID_BY_EAN"
                }
            })
            .then((response) => {
                let id = response.data.id;
                if (id > 0) {
                    this.props.history.push(Session.getItem("basename") + "/product/" + id);
                } else {
                    this.setState({
                        showProductEanWarning: true
                    })
                }

            })
            .catch((error) => {
                this.setState({
                    showProductEanWarning: true
                })
                PT.handleError(error, this.props.history);
            })
    }

    _handleSearch = (query) => {
        this.setState({isLoading: true});
        axios.get(Session.getItem("endpoint") + 'PortalServlet', {params: {idMandant: Session.idMandant,idCompany:Session.getItem("idCompany"),idContact:Session.getItem("idContact"),idLanguage:Session.getItem("idLanguage"),idCurrency:Session.getItem("idCurrency"), query: query, action: "GET_SEARCH_RESULTS"}})
            .then((response) => {
                this.setState({
                    isLoading: false,
                    options:response.data.options,
                });
            })
            .catch((error) => {
                PT.handleError(error, this.props.history);
            })


    };
    _handleSelect = (selected) => {

        if(selected[0]!==undefined) {
            let basename = "/" + Session.instance + "/" + Session.idMandant;
            this.props.history.replace(basename + "/" + selected[0].type + "/" + selected[0].id);
            this.setState({selected:selected},()=>this.clearInput())
        }

/*
       if(selected!==undefined && selected[0]!==undefined){
           let basename = "/" + Session.instance + "/" + Session.idMandant;
           this.props.history.replace(basename+"/"+selected[0].type+"/"+selected[0].id);
       }
*/
    };

    _handleEnterKey = (e) => {
        if (e && (e.key === 'Enter' || e.keyCode === 13)) {
            try {
                const inputEl = this._typeahead && typeof this._typeahead.getInput === 'function' ? this._typeahead.getInput() : null;
                const query = inputEl && inputEl.value ? String(inputEl.value).trim() : '';
                if (query.length > 0) {
                    Session.setItem("searchQuery", query);
                    // Dispatch a custom event so SearchPage can react if it's already mounted
                    try {
                        const evt = new CustomEvent('globalSearchSubmit', { detail: { query } });
                        window.dispatchEvent(evt);
                    } catch (evErr) {
                        // ignore if CustomEvent is not available
                    }
                    let basename = "/" + Session.instance + "/" + Session.idMandant;
                    this.props.history.replace(basename + "/search");
                    this.clearInput();
                }
            } catch (err) {
                // fallback – ignore errors silently to keep UX smooth
            }
        }
    };

    clearInput(){
        const instance = this._typeahead;
        setTimeout(function(){
            console.log(instance)
            instance.clear()
            this.setState({
                selected:[]
            },()=>instance.clear())
        }.bind(this), 200);
    }

    render() {
        return (
            <div>
                <div className="visible-xs-block visible-sm-block">
                    {canScan() ?
                        <i className="icon icon-camera position-left mr-10" style={{paddingRight:"10px"}} onClick={this._scanBarCode}/>
                        : null}
                    <i className="icon icon-search4 position-left" onClick={() => this.setState({showSearch: !this.state.showSearch})}/>
                    <div  className={"search-popup z-index999 " + (this.state.showSearch ? "" : "hidden")}>
                        <AsyncTypeahead
                            ref={(ref) => this._typeahead = ref}
                            {...this.state}
                            id={"Search"}
                            minLength={3}

                            className={"search-dropdown right0"}
                            filterBy={(option, props) => {
                                return true;
                            }}
                            clearButton
                            searchText={ST.get("searching","global")}
                            emptyLabel={ST.get("no_results","global")}
                            labelKey="searchString"
                            highlightOnlyResult={true}

                            onSearch={this._handleSearch}
                            onChange={this._handleSelect}
                            onKeyDown={this._handleEnterKey}
                            placeholder={ST.get("search","global")}
                            renderMenuItemChildren={(option, props) => (
                                <SearchResult  option={option} id={option.id} key={option.id} />
                            )}
                        />
                    </div>
                </div>
                <div className="hidden-xs hidden-sm" style={{display: "inline-flex"}}>
                    {canScan() ?
                    <i className="icon icon-barcode2 position-left ean-camera" onClick={this._scanBarCode}/>
                    : null }
                    <AsyncTypeahead
                        {...this.state}
                        ref={(ref) => this._typeahead = ref}
                        id={"Search"}
                        minLength={3}
                        className={"search-dropdown"}
                        filterBy={(option, props) => {
                            return true;
                        }}
                        clearButton
                        searchText={ST.get("searching","global")}
                        emptyLabel={ST.get("no_results","global")}
                        labelKey="searchString"
                        highlightOnlyResult={true}
                        onSearch={this._handleSearch}
                        onChange={this._handleSelect}
                        onKeyDown={this._handleEnterKey}
                        placeholder={ST.get("search","global")}
                        renderMenuItemChildren={(option, props) => (
                            <SearchResult  option={option} id={option.id} key={option.id} />
                        )}
                    />
                </div>
                <WarningDialog
                    show={this.state.showProductEanWarning}
                    onHide={() => this.setState({showProductEanWarning: false})}
                    warningText={ST.get("product_not_found", "product")}
                />
            </div>
        );
    }
}